module.exports = __webpack_public_path__ + "4e2f9501dcfdb55ba592bfde557f97ad.svg";